var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomnavCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M97.4,222.7c-6.17,0-11.2-5.02-11.2-11.19s5.02-11.19,11.2-11.19,11.19,5.02,11.19,11.19-5.02,11.19-11.19,11.19Zm0-15.52c-2.39,0-4.34,1.94-4.34,4.33s1.95,4.33,4.34,4.33,4.33-1.94,4.33-4.33-1.94-4.33-4.33-4.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M182.81,222.7c-6.17,0-11.2-5.02-11.2-11.19s5.02-11.19,11.2-11.19,11.19,5.02,11.19,11.19-5.02,11.19-11.19,11.19Zm0-15.52c-2.39,0-4.34,1.94-4.34,4.33s1.95,4.33,4.34,4.33,4.33-1.94,4.33-4.33-1.94-4.33-4.33-4.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M178.15,176.12H102.67c-9.43-.02-17.38-6.78-18.91-16.07l-12.98-68.49c-.04-.16-.07-.32-.09-.49l-7.19-37.98h-28.22c-1.9,0-3.43-1.53-3.43-3.43s1.53-3.43,3.43-3.43h31.06c1.65,0,3.06,1.17,3.37,2.79l7.24,38.22H206.1c1.02,0,1.98,.45,2.63,1.23,.65,.78,.92,1.81,.74,2.81l-12.4,68.82c-1.53,9.25-9.5,16.01-18.93,16.02ZM78.24,94.1l12.27,64.75c1,6.05,6.11,10.4,12.16,10.41h75.47c6.06,0,11.18-4.35,12.17-10.33l11.68-64.83H78.24Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomnavCart);
export default __webpack_public_path__ + "static/media/bottomnav-cart.dd587cb393a2a7a65adf43f4c79e3704.svg";
export { ForwardRef as ReactComponent };